module.exports = "/images/new-form.png?70d7feaf073651ce6ecbd0853513299a";